<!--suppress UnnecessaryLabelJS -->
<template>
	<v-card>
		<v-card-title>
			<v-spacer />
			<v-spacer />
			<v-text-field
				v-model="lookingFor"
				append-icon="mdi-magnify"
				label="חיפוש"
				single-line
				hide-details
			/>
		</v-card-title>
		<v-data-table
			:headers="headers"
			:items="users"
			:loading="loading"
			class="elevation-1"
			:search="lookingFor"
		>
			<v-progress-linear
				slot="progress"
				color="blue"
				indeterminate
			/>

			<template #item.action="{item}">
				<action-td
					:item="item"
					module="user"
					@edit="onEdit"
				/>
			</template>
		</v-data-table>
	</v-card>
</template>

<script>

	import { types } from "src/store/modules/User.module";
	import FilterAble from "src/mixins/FilterAble";
	import ActionTd from "src/components/AcationTd";

	export default {
		name: "users-table",
		components: {
			ActionTd,
		},
		props: [],
		mixins: [new FilterAble(types)],
		data () {
			return {
				loading: false,
				headers: [
					{ text: "שם", value: "name" },
					{ text: "אימייל", value: "email" },
					{ text: "נוצר בתאריך", value: "created_at" },
					{ text: "פעולות", value: "action" },
				],
				lookingFor: null,
				showDialog: false,
			};
		},
		computed: {
			users () {
				return this.$store.state.UserModule.users;
			},
		},
		methods: {
			onEdit (User) {
				this.$emit("edit", User);
			},
		},
	};

</script>

<style>

</style>
